import { connect } from "react-redux"

import SystemMigration from '../SystemMigration'

import {migrationEntityActions, migrationListActions} from '../../../../js/actions/index'

class Themis extends SystemMigration {
    constructor() {
        super()
        this.state = {
            headers: ["Namespace", "Processos", "Contatos sem processo", "Inicio", "Fim", "Ambiente", "Status", ""],
            defaultValues: {
                FIREBIRD: {sqlFolder: '/sql/themis/firebird', encoding: 'WIN1252'},
                ORACLE: {sqlFolder: '/sql/themis/oracle', encoding: 'WIN1252'},
                SQLSERVER: {sqlFolder: '/sql/themis/sqlserver', encoding: 'WIN1252'},
                DATABASES: [
                    {label: 'Firebird', value: 'FIREBIRD'},
                    {label: 'Oracle', value: 'ORACLE'},
                    {label: 'SQL Server', value: 'SQLSERVER'}
                ],
                ORIGIN: 'THEMIS',
                NAME: 'Themis'
            }
        }
    }
}

const mapStateToProps = state => {
    return {
        newMigration: state.migrationEntityReducer.entity,
        list: state.migrationsListReducer.themis.filtered
    }
}

const mapDispatchToProps = dispatch => {
    return {
        update: migrationEntity => dispatch(migrationEntityActions.updateMigrationEntity(migrationEntity)),
        clear: () => dispatch(migrationEntityActions.clearMigrationEntity()),
        showAll: () => dispatch(migrationListActions.showAllThemisMigrations())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Themis);



// WEBPACK FOOTER //
// ./src/views/components/systems/themis/Themis.js